import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-800 text-gray-300 mt-auto">
      <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-white font-semibold mb-4">About PlantaDay</h3>
            <p className="text-sm">
              A homeowner-friendly way to explore yard ideas, learn what works, find designers, and get curated plant
              guidance—built on tools landscape professionals trust.
            </p>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">Explore</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/" className="hover:text-white transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/ideas" className="hover:text-white transition-colors">
                  Get Ideas (AI + photo)
                </Link>
              </li>
              <li>
                <Link to="/find-designer" className="hover:text-white transition-colors">
                  Find a Designer
                </Link>
              </li>
              <li>
                <Link to="/learn" className="hover:text-white transition-colors">
                  Learn
                </Link>
              </li>
              <li>
                <Link to="/watch" className="hover:text-white transition-colors">
                  Watch &amp; tips
                </Link>
              </li>
              <li>
                <Link to="/login" className="hover:text-white transition-colors">
                  Sign in (designers)
                </Link>
              </li>
              <li>
                <Link to="/create-account" className="hover:text-white transition-colors">
                  Create account
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">Legal</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/terms" className="hover:text-white transition-colors">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="hover:text-white transition-colors">
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-6 text-center text-sm">
          <p>&copy; {new Date().getFullYear()} PlantaDay. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
